import { Component, CUSTOM_ELEMENTS_SCHEMA, EventEmitter, Input, Output, SimpleChanges, ViewChild } from '@angular/core';
import { models, service, Embed } from 'powerbi-client';
import { PowerBIEmbedModule, PowerBIReportEmbedComponent, PowerBIVisualEmbedComponent } from 'powerbi-client-angular';


import pbiregular from "../../assets/powerbi_theme_regular.json";

@Component({
  selector: 'app-powerbi-page',
  imports: [PowerBIEmbedModule],
  templateUrl: './powerbi-page.component.html',
  styleUrl: './powerbi-page.component.css',
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class PowerbiPageComponent {

  @Input() token: string;
  @Input() reportid: string;
  @Input() pageid: string;
  @Input() groupid: string;
  @Input() filters: any;

  @ViewChild(PowerBIReportEmbedComponent) reportObj!: PowerBIReportEmbedComponent;
  @ViewChild('reportEmbedModal') reportEmbed: any;

  @Output() productFilterChanged = new EventEmitter<Array<string>>();

  embedConfig: models.IReportEmbedConfiguration
  eventHandlersMap: Map<any, any>;
  report;

  //All configuration items for Power BI component are registered in this part
  ngOnInit(): void {

    //Here the event Handlers are defined
    this.eventHandlersMap = new Map([
      ['loaded', () => {
        console.log('Report has loaded');
        this.report.getPages().then((pages: models.IPage[]) => {
          console.log('Available pages:', pages);
        });
      },
      ],
      ['rendered', () => {
        console.log("Report has Rendered");
      }],
      ['error', (event?: service.ICustomEvent<any>) => {
        console.log(event);
        if (event) {
          console.error(event.detail);

        }
      },
      ],
    ]) as Map<string, (event?: service.ICustomEvent<any>, embeddedEntity?: Embed) => void | null>;

    //This is the main configuration of the embedded power bi
    this.embedConfig = {
      type: "report",
      id: this.reportid,
      pageName: this.pageid,
      embedUrl:
        "https://app.powerbi.com/reportEmbed?reportId=" + this.reportid + "&groupId=" + this.groupid,
      accessToken: this.token,
      permissions: models.Permissions.All,
      tokenType: models.TokenType.Embed,
      filters: this.filters,
      theme: {
        themeJson: pbiregular,
      },
      settings: {
        background: models.BackgroundType.Transparent,
        panes: {
          filters: {
            visible: false,
          },
          pageNavigation: {
            visible: false,
          },
        },
        layoutType: models.LayoutType.Custom,
        customLayout: {
          displayOption: models.DisplayOption.FitToPage,
        }
      }
    }

  }

  ngAfterViewInit(): void {
    this.report = this.reportObj.getReport();
  }


}
